import CustomerTableActions from './CustomerTableActions'
export default CustomerTableActions
